import { render, staticRenderFns } from "./Title.vue?vue&type=template&id=2cef1eea&scoped=true"
import script from "./Title.vue?vue&type=script&setup=true&lang=js"
export * from "./Title.vue?vue&type=script&setup=true&lang=js"
import style0 from "./Title.vue?vue&type=style&index=0&id=2cef1eea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cef1eea",
  null
  
)

export default component.exports